import axios from "axios";
import * as Constants from "../constant";

const usermangementTable = async (user) => {
	try {
		const response = await axios.get(
			`${Constants?.LOCAL_URL}/users/Account/${user.UserId}`
		);
		return response.data;
	} catch (error) {
		return error;
	}
};
export default usermangementTable;
